<template lang="pug">
  div
    .heading BGP Routes
    .subtitle This page allows you to lookup BGP routes for a specific address.
    BGPRoutesLookup
</template>
<script>
import BGPRoutesLookup from "@/components/BGPRoutesLookup";

export default {
  components: {
    BGPRoutesLookup: BGPRoutesLookup,
  },
};
</script>
